import h, { FunctionComponent } from 'preact';

const PriceList: FunctionComponent<PriceListProps> = () => {
    return <div class="price-list  d-flex flex-row-reverse">
        <a href="/account/price-list" class="d-flex align-items-center text-sm line-height-sm px-0 text-blue font-weight-bold">
            <i aria-hidden="true" class="ev-icon ev-icon-pdf mr-2"></i> View price list
        </a>
    </div>;
};

interface PriceListProps {
}

export default PriceList;
